import { RouteConfig } from "../../types/RouteConfig";
import { logoutRoute } from "./logout/route";

export const accountRoutes: RouteConfig<'with-children'> = {
    name: 'Account',
    children: [
        logoutRoute,
    ]
}